export const DEVICE_TYPE = { 1: 'Холодная вода', 2: 'Горячая вода', 3: 'Универсальный счетчик' };
